// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles_form__sAJv5 {\n    display: grid;\n    grid-template-columns: auto max-content;\n    grid-gap: 10px;\n\n    align-items: center;\n\n    min-width: 150px;\n}", "",{"version":3,"sources":["webpack://./src/Forms/search/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uCAAuC;IACvC,cAAc;;IAEd,mBAAmB;;IAEnB,gBAAgB;AACpB","sourcesContent":[".form {\n    display: grid;\n    grid-template-columns: auto max-content;\n    grid-gap: 10px;\n\n    align-items: center;\n\n    min-width: 150px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": "styles_form__sAJv5"
};
export default ___CSS_LOADER_EXPORT___;
